import _ from "lodash";
import React, { useEffect, useMemo, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import BeatLoader from "react-spinners/BeatLoader";
import {
  useAddTrainingMutation,
  useGetAllCategoryQuery,
  useUpdateTrainingMutation,
} from "../../Data/services/trainingApi";
import Toast, { ErrorToast, SuccessToast } from "../../Hooks/useToast";
import { Button, Input, UploadButton } from "../CustomComponents";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import { useUploadImageS3Mutation } from "../../Data/services/profileRequestApi";
import axios from "axios";

const TrainingModal = ({
  handleUpdateModalClose,
  data,
  handleUpdate,
  refetch,
}) => {
  const { handleSubmit, control, setValue, watch } = useForm({});

  const [updateCategory, { isLoading: addloading }] =
    useUpdateTrainingMutation();
  const [addCategory, { isLoading: editLoading }] = useAddTrainingMutation();
  const [UploadImageS3, { isLoading: uploading }] = useUploadImageS3Mutation();
  const updateLoading = addloading || editLoading;
  const { data: category, error } = useGetAllCategoryQuery({
    search: "",
    limit: 1000,
    page: 1,
  });
  const [userSlug, setUserSlug] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [file, setFile] = useState(null);
  const [imageFiles, setImageFiles] = useState([]);
  const [S3Img, setS3Image] = useState(null);

  const statusList =
    (category?.data &&
      category?.data?.map((x) => {
        return { label: x.name, value: x.id };
      })) ||
    [];

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (data) {
      console.log(data);
      setUserSlug(data.id);
      setValue("name", data.name);
      setValue("description", data.description);
      setImageFiles([...imageFiles, data.image_url]);
      setValue("training_category_id", data.training_category_id);
      setSelectedStatus(data.training_category_id);
      setValue('cover_image_url', data.image_url)
    }
  }, [data, mounted]);

  const handleStatusChange = (value) => {
    setSelectedStatus(value);
  };

  const isMultileFileUpload = useMemo(() => false, []);
  const fileAcceptParams = useMemo(() => "image/png, image/jpeg", []);
  const cover_image_url = watch("cover_image_url");

  const handleAddfilesAndSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFile(file);
      const doc = URL.createObjectURL(file);
      setImageFiles([...imageFiles, doc]);
    }
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);

    const fileExtension = selectedFile?.name.split(".").pop(); 
    const payload = {
      file_name: `user/${Date.now()}.${fileExtension}`,
      content_type: selectedFile?.type,
    };

    try {
      const result = await UploadImageS3({ params: payload }).unwrap();
      setS3Image(result?.data?.presignedUrl); 
    } catch (e) {
      ErrorToast(e?.data?.message || "Upload failed");
    }
  };

  // const handleImageS3Submit = async () => {
  //   if (!file || !S3Img) {
  //     console.error("File or S3 URL is missing.");
  //     return false;
  //   }
  
  //   console.log("File:", file);
  //   console.log("File type:", file.type);
  //   console.log("File size:", file.size);
  //   console.log("Is file instance of File?", file instanceof File);
  
  //   try {
  //     const response = await axios.put(S3Img, file, {
  //       headers: {
  //         'Content-Type': file.type, 
  //       },
  //     });
  
  //     if (response.status === 200) {
  //       console.log("✅ Upload successful!");
  //       return true;
  //     } else {
  //       console.error("❌ Upload failed:", response.status);
  //       ErrorToast("Upload failed");
  //       return false;
  //     }
  //   } catch (error) {
  //     console.error("❌ Upload error:", error);
  //     return false;
  //   }
  // };

  const handleImageS3Submit = async () => {
    if (S3Img && file) {
      try {
        const uploadResponse = await fetch(S3Img, {
          method: "PUT",
          headers: {
            "Content-Type": file.type,
          },
          body: file,
        });

        if (uploadResponse.ok) {
          console.log("Upload successful!");
          return true;
        } else {
          console.error("Upload failed.");
          return false;
        }
      } catch (error) {
        console.error("Upload error:", error);
        return false;
      }
    }
    return false;
  };

  const OnSubmit = async (record) => {
    if (!file) {
      delete record["image_url"];
    }

    if (file && S3Img) {
      const uploadSuccess = await handleImageS3Submit();
      if (!uploadSuccess) {
        ErrorToast("Image upload failed");
        return;
      }

      const uploadedFileUrl =
        S3Img.split("?")[0] || "https://picsum.photos/200/300";
      record["image_url"] = uploadedFileUrl;
      console.log(uploadedFileUrl);
    }


    try {
      const payload = {
        slug: data?.id,
        data: { ...record, image_url: record["image_url"] },
      };

      let response;
      if (data) {
        response = await updateCategory(payload);
      } else {
        response = await addCategory(payload);
      }

      if (response?.error?.status === 400) {
        console.log(response?.error?.data?.message);
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response?.error?.status === 500) {
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response?.data) {
        SuccessToast(response?.data?.message);
        handleUpdateModalClose();
        refetch();
      }
    } catch (error) {
      console.log(error);
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      }
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleUpdateModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-semibold m-0 black-text">
              {data ? "Update" : "Add"} Training
            </p>
            <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleUpdateModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <p className="text-body-tertiary">{data?.name}</p>
            <Form onSubmit={handleSubmit(OnSubmit)}>
              <Row>
                <Col sm={12}>
                  <UploadButton
                    label="Upload Cover"
                    classes="mb-2"
                    labelClasses="p-5"
                    isMultileFileUpload={isMultileFileUpload}
                    fileAcceptParams={fileAcceptParams}
                    file={file || cover_image_url}
                    handleFileChange={handleFileChange}
                  />
                </Col>
                <Col md={12}>
                  <p className="m-0 black-text">Training Name</p>
                  <Controller
                    control={control}
                    name="name"
                    rules={{
                      required: "The Training Name is required.",
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        type="text"
                        value={value}
                        onChange={onChange}
                        innerRef={ref}
                      />
                    )}
                  />
                </Col>
                <Col md={12}>
                  <p className="m-0 black-text mt-2">Category</p>
                  <Controller
                    control={control}
                    name="training_category_id"
                    rules={{}}
                    defaultValue={selectedStatus}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <SelectFieldComponent
                        firstOption={
                          _.isEmpty(selectedStatus)
                            ? "Select Category"
                            : selectedStatus
                        }
                        optionsList={statusList}
                        onSelectChange={(newValue) => {
                          console.log(newValue);
                          onChange(newValue);
                          setSelectedStatus(newValue);
                        }}
                      />
                    )}
                  />
                </Col>
                <Col md={12}>
                  <p className="m-0 black-text mt-3">Description</p>
                  <Controller
                    control={control}
                    name="description"
                    // defaultValue={subscriptionDescription}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        type="text"
                        value={value}
                        onChange={(e) => {
                          onChange(e);
                        }}
                        innerRef={ref}
                        as="textarea"
                        placeholder="Description"
                        rows={4}
                      />
                      //   <Form.Control
                      //     as="textarea"
                      //     rows={3}
                      //     value={value || ""}
                      //     onChange={(e) => {
                      //       onChange(e);
                      //     }}
                      //     placeholder="Description"
                      //   />
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Button
                    classes={`${cssStyles.cardBtn} mt-4 ${
                      updateLoading ? "bg-white-subtle" : ""
                    }`}
                    text={
                      updateLoading ? (
                        <BeatLoader size={10} />
                      ) : data ? (
                        "Update"
                      ) : (
                        "Add"
                      )
                    }
                    // onClick={handleSubmit}
                    type="Submit"
                  ></Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default TrainingModal;
